export const colors = {
  backgroundDark: 'rgb(16, 18, 20)',
  defaultRedDark: 'rgb(250, 80, 80)',
  defaultRedLight: 'rgb(255, 182, 193)',
  defaultBlueDark: 'rgb(70, 130, 180)',
  defaultBlueLight: 'rgb(173, 216, 230)',
  gridBorderDark: '1px solid rgba(34, 38, 43)',
  gridBorderLight: '1px solid hsl(215, 15%, 92%)',
  gridBackgroundDark: 'rgba(22, 24, 27)',
  gridBackgroundLight: 'hsla(215, 15%, 97%, 0.5)',
};
